import { z } from 'zod'

import { DateZod } from '../common'

export const PromotionPlacementZod = z.enum([
  'email',
  'milestone',
  'hero',
  'volunteerProfile',
  'clientInfo',
  'volunteerInfo',
])

export type PromotionPlacement = z.infer<typeof PromotionPlacementZod>

export const PromotionTypeZod = z.enum(['local', 'national', 'fallback'])
export type PromotionType = z.infer<typeof PromotionTypeZod>

export const PromotionZod = z.object({
  type: PromotionTypeZod,
  initiativeId: z.string().min(1, 'Initiative ID is required'),
  regionId: z.string().optional(),
  partnerName: z.string().optional(),
  title: z.string().optional(),
  targetUrl: z.string().optional(),
  active: z.boolean(),
  used: z.boolean().optional(),
  placements: PromotionPlacementZod.array().optional().default([]),
  creativeUrls: z.record(PromotionPlacementZod, z.string()).optional().default({}),
  createdAt: DateZod,
})
